import { useEffect } from 'react';
import { t } from '@lingui/core/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { IntroducerOnboarding } from 'components/Registration/IntroducerOnboarding/IntroducerOnboarding';
import { ReferralRegistrationForm } from 'components/Registration/ReferralRegistrationForm/ReferralRegistrationForm';
import { RegistrationFormDE } from 'components/Registration/RegistrationFormDE/RegistrationFormDE';
import { useLocale } from 'hooks/useLocale';
import { Route, Routes, useNavigate, useSearchParams } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const RegisterPage = () => {
  const { isDE } = useLocale();
  const navigate = useNavigate();
  const isLoggedIn = getCookie('isLoggedIn');
  const [searchParams] = useSearchParams();
  const inviteId = searchParams.get('introducer') as string | undefined;

  useEffect(() => {
    // Cookie isLoggedIn comes as a string | null and not a boolean
    if (isLoggedIn === 'True') {
      navigate(PATH_NAMES.home());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const RegistrationFormWrapper = () => (
    <BaseLayout pageTitle={t`Register | Introducer Portal`}>
      {isDE ? (
        <RegistrationFormDE />
      ) : inviteId ? (
        <ReferralRegistrationForm />
      ) : (
        <IntroducerOnboarding />
      )}
    </BaseLayout>
  );

  const HeadquartersRoute = () => {
    useEffect(() => {
      if (!isDE) {
        navigate(PATH_NAMES.notFound());
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDE]);

    if (!isDE) return null;

    return <RegistrationFormWrapper />;
  };

  return (
    <Routes>
      <Route path="/" element={<RegistrationFormWrapper />} />
      <Route path=":headquarters" element={<HeadquartersRoute />} />
    </Routes>
  );
};
